module.exports = __webpack_public_path__ + "static/media/img-gathering.98e96c85.png";